import { useContext } from 'react';
import { TimeContext } from './TimeProvider';
import { intervalToDuration } from 'date-fns/intervalToDuration';
import { differenceInMilliseconds } from 'date-fns/differenceInMilliseconds';

interface TimmerProps {
    deployBlockTime: number;
    timers: number[];
    children: (formattedElapsedTime: string, timersComplete: boolean[]) => JSX.Element;
}

export function DeployBlockTimer({ deployBlockTime, timers, children }: TimmerProps) {
    const currentTime = useContext(TimeContext);

    const { hours = 0, minutes = 0, seconds = 0 } = intervalToDuration({ start: deployBlockTime * 1000, end: currentTime || Date.now() });

    let tokenTime: string;
    if (hours > 0) {
        tokenTime = `${hours}h`;
    } else if (minutes > 0) {
        tokenTime = `${minutes}m`;
    } else {
        tokenTime = `${seconds}s`;
    }

    return children(
        tokenTime,
        timers.map((timer) => timer <= differenceInMilliseconds(currentTime || Date.now(), deployBlockTime * 1000)),
    );
}

export function Timer({ deployBlockTime, timers, children }: TimmerProps) {
    const currentTime = useContext(TimeContext);

    return children(String((currentTime ?? Date()).valueOf()), []);
}
